import { render, staticRenderFns } from "./ReportMailWorkflow.vue?vue&type=template&id=728b7e96&scoped=true&"
import script from "./ReportMailWorkflow.vue?vue&type=script&lang=js&"
export * from "./ReportMailWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ReportMailWorkflow.vue?vue&type=style&index=0&id=728b7e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728b7e96",
  null
  
)

export default component.exports